<template>
  <div class="qrcode-page">
    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="banner-overlay"></div>
      <v-container class="hero-content">
        <h2 class="hero-title">QR Code Generator</h2>
        <p class="hero-subtitle">Generate your personalized QR code</p>
      </v-container>
    </div>

    <!-- Main Content -->
    <v-container class="content-container">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">

          <!-- QR Code Generator Card -->
          <v-card class="qr-generator-card mt-6" elevation="12">
            <div class="card-header">
              <v-icon color="white" class="mr-3" size="28">mdi-email-check</v-icon>
              <span class="card-header-title">Enter Primary/Membership email</span>
            </div>

                      <!-- Logo Card -->
          <v-card class="logo-card" elevation="8">
            <v-card-text class="text-center pa-6">
              <div class="logo-wrapper">
                <v-img
                  :src="require(`@/assets/thiruvalluvar.png`)"
                  width="141"
                  max-height="160"
                  contain
                  class="mx-auto"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>

            <v-card-text class="pa-6">
              <!-- Email Input -->
              <v-text-field
                v-model="message"
                label="Primary Email"
                placeholder="Enter your email address"
                outlined
                dense
                :rules="emailRules"
                type="email"
                class="modern-input mt-4"
                prepend-inner-icon="mdi-email-outline"
                color="primary"
              ></v-text-field>

              <!-- QR Code Display -->
              <div v-if="message" class="qr-code-wrapper">
                <div class="qr-code-container">
                  <qr-code
                    ref="qrcode"
                    :text="message"
                    label="False"
                    :size="250"
                    color="#667eea"
                    error-level="L"
                  ></qr-code>
                </div>

                <!-- Download Button -->
                <v-btn
                  color="primary"
                  x-large
                  block
                  class="download-btn mt-4"
                  elevation="4"
                  @click="downloadQRCode"
                >
                  <v-icon left size="24">mdi-download</v-icon>
                  Download QR Code
                </v-btn>
              </div>

              <!-- Empty State -->
              <div v-else class="empty-state">
                <v-icon color="grey lighten-1" size="80">mdi-qrcode</v-icon>
                <p class="empty-state-text">Your QR code will appear here</p>
              </div>
            </v-card-text>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  data: () => ({
    message: '',

  }),
  methods: {
    downloadQRCode() {
      // Get the QR code canvas element
      const canvas = this.$el.querySelector('canvas')

      if (canvas) {
        // Convert canvas to blob
        canvas.toBlob((blob) => {
          // Create a download link
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `QRCode-${this.message}.png`

          // Trigger download
          document.body.appendChild(link)
          link.click()

          // Cleanup
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* ========================================
   QR CODE PAGE - MODERN STYLING
   ======================================== */

.qrcode-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
}

/* Hero Banner */
.hero-banner {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 32px 20px;
  text-align: center;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="rgba(255,255,255,0.1)" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,138.7C960,139,1056,117,1152,101.3C1248,85,1344,75,1392,69.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>') no-repeat bottom;
  background-size: cover;
  opacity: 0.3;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-icon-wrapper {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  animation: float 3s ease-in-out infinite;
}

.hero-icon-wrapper .v-icon {
  font-size: 42px !important;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.hero-title {
  font-size: 32px;
  font-weight: 900;
  color: white;
  margin: 0 0 6px 0;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
  font-weight: 500;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Content Container */
.content-container {
  margin-top: -30px;
  position: relative;
  z-index: 2;
  padding-bottom: 40px;
}

/* Logo Card */
.logo-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: white;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1) !important;
  border: 2px solid #f5f5f5;
  transition: all 0.3s ease;
}

.logo-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.15) !important;
}

.logo-wrapper {
  padding: 16px;
}

/* QR Generator Card */
.qr-generator-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
  border: 2px solid #f5f5f5;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  color: white;
}

.card-header-title {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Instruction Box */
.instruction-box {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  padding: 16px 20px;
  border-radius: 12px;
  border-left: 4px solid #667eea;
}

.instruction-text {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.5;
}

/* Modern Input */
.modern-input ::v-deep .v-input__control {
  border-radius: 12px;
}

.modern-input ::v-deep .v-text-field__details {
  padding-top: 8px;
}

.modern-input ::v-deep fieldset {
  border-width: 2px;
  border-color: #e0e0e0;
  transition: all 0.3s ease;
}

.modern-input ::v-deep .v-input--is-focused fieldset {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* QR Code Wrapper */
.qr-code-wrapper {
  margin-top: 24px;
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.qr-code-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 24px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow:
    inset 0 2px 8px rgba(0, 0, 0, 0.05),
    0 4px 16px rgba(0, 0, 0, 0.08);
  border: 2px solid #f0f0f0;
}

/* Download Button */
.download-btn {
  border-radius: 14px !important;
  padding: 16px 32px !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.4) !important;
  transition: all 0.3s ease !important;
}

.download-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.5) !important;
}

.download-btn:active {
  transform: translateY(-1px);
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  margin-top: 24px;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-radius: 16px;
  border: 2px dashed #e0e0e0;
}

.empty-state-text {
  font-size: 16px;
  color: #9e9e9e;
  margin-top: 16px;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 960px) {
  .hero-banner {
    padding: 32px 20px;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-subtitle {
    font-size: 15px;
  }

  .hero-icon-wrapper {
    width: 70px;
    height: 70px;
    margin-bottom: 12px;
  }

  .hero-icon-wrapper .v-icon {
    font-size: 42px !important;
  }

  .card-header {
    padding: 20px 24px;
  }

  .card-header-title {
    font-size: 20px;
  }

  .qr-generator-card .pa-6 {
    padding: 20px !important;
  }
}

@media (max-width: 600px) {
  .hero-banner {
    padding: 28px 16px;
  }

  .hero-title {
    font-size: 26px;
  }

  .hero-subtitle {
    font-size: 14px;
  }

  .hero-icon-wrapper {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }

  .hero-icon-wrapper .v-icon {
    font-size: 36px !important;
  }

  .card-header {
    padding: 16px 20px;
  }

  .card-header-title {
    font-size: 18px;
  }

  .card-header .v-icon {
    font-size: 24px !important;
  }

  .qr-generator-card .pa-6 {
    padding: 16px !important;
  }

  .instruction-box {
    padding: 12px 16px;
  }

  .instruction-text {
    font-size: 13px;
  }

  .qr-code-container {
    padding: 20px;
  }

  .download-btn {
    font-size: 15px !important;
    padding: 14px 24px !important;
  }

  .empty-state {
    padding: 40px 16px;
  }

  .empty-state .v-icon {
    font-size: 60px !important;
  }

  .empty-state-text {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .hero-title {
    font-size: 24px;
  }

  .hero-subtitle {
    font-size: 13px;
  }

  .card-header-title {
    font-size: 16px;
  }

  .instruction-text {
    font-size: 12px;
  }

  .download-btn {
    font-size: 14px !important;
  }
}
</style>